import React from 'react'
import { Surface } from '@/components/admin/atoms/layout/Surface'
import { Padding } from '@/components/admin/atoms/layout/Padding'
import { Inline } from '@/components/admin/atoms/layout/Inline'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Muted } from '@/components/admin/atoms/typography/Muted'
import { StatValue } from '@/components/admin/atoms/feedback/StatValue'
import { StatIcon } from '@/components/admin/atoms/feedback/StatIcon'

type StatColor = 'primary' | 'success' | 'warning' | 'info' | 'error' | 'muted'

interface StatCardProps {
  label: string
  value: number
  icon: React.ReactNode
  color?: StatColor
  trend?: React.ReactNode
  accentBorder?: boolean
  className?: never
}

export const StatCard: React.FC<StatCardProps> = ({
  label, value, icon, color = 'primary', trend, accentBorder = false,
}) => (
  <Surface variant="card" radius="lg">
    <Padding all="5">
      <Inline justify="between" align="start">
        <Stack gap="1">
          <Muted>{label}</Muted>
          <StatValue>{value}</StatValue>
          {trend}
        </Stack>
        <StatIcon icon={icon} color={color} />
      </Inline>
    </Padding>
  </Surface>
)
